/*
  This function calculates the duration between two times.
  It takes two strings in the format "HH:mm" as arguments.
  It returns an object with the duration in hours and minutes.
*/
export function calculateDuration(
  startTime: string,
  endTime: string
): { hours: number; minutes: number } {
  const [startHour, startMinute] = startTime.split(':').map(Number)
  const [endHour, endMinute] = endTime.split(':').map(Number)

  // Convert the hours and minutes to total minutes
  const startTotalMinutes = startHour! * 60 + startMinute!
  const endTotalMinutes = endHour! * 60 + endMinute!

  // Calculate the time difference in minutes
  let timeDifference = endTotalMinutes - startTotalMinutes

  // If the end time is on the next day, add 24 hours (in minutes) to the difference
  if (timeDifference < 0) {
    timeDifference += 24 * 60
  }

  // Convert the time difference back to hours and minutes
  const hours = Math.floor(timeDifference / 60)
  const minutes = timeDifference % 60

  return { hours, minutes }
}
